export const omit = (obj: Record<string, any>, keys: string[]) => {
  if (!obj) {
    return {};
  }

  const invalidKeys = new Set(keys);

  return Object.fromEntries(
    Object.entries(obj).filter(([key]) => !invalidKeys.has(key))
  );
};
